import { useState } from 'react'
import { useNavigate } from 'react-router'
import { AudioUploadDropzone } from '#app/components/audio-upload-dropzone.tsx'
import { useAudioUpload } from '#app/hooks/useAudioUpload.ts'

export default function EditorUploadStep() {
	const navigate = useNavigate()
	const { upload, progress, statusMessage, largeUploadInProgress } =
		useAudioUpload()
	const [error, setError] = useState<string | null>(null)
	const [uploading, setUploading] = useState(false)

	async function handleFile(file: File) {
		setError(null)
		// Anonymous (pre-signup) uploads are allowed — the server allocates a
		// guest-owned file; signup/login is only required later, at download.
		setUploading(true)
		try {
			const { fileId } = await upload(file)
			await navigate(`/editor/edit/${fileId}`)
		} catch (e) {
			const message = (e as Error).message
			if (
				message.toLowerCase().includes('fetch failed') ||
				message.toLowerCase().includes('failed to fetch')
			) {
				setError('Upload failed due to a temporary network issue. Please retry.')
			} else {
				setError(message)
			}
		} finally {
			setUploading(false)
		}
	}

	return (
		<div className="space-y-4 max-w-xl mx-auto">
			<h2 className="text-xl font-semibold">Upload your audio</h2>
			<AudioUploadDropzone
				onUpload={handleFile}
				progress={progress}
				uploading={uploading}
				error={error}
				statusMessage={statusMessage}
				largeUploadWarning={largeUploadInProgress}
			/>
		</div>
	)
}
